(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/game/views/joker/joker.js') >= 0) return;  svs.modules.push('/components/numbergames/game/views/joker/joker.js');
(function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_svs.numbergames=_svs.numbergames||{};
_svs.numbergames.game=_svs.numbergames.game||{};
_svs.numbergames.game.templates=_svs.numbergames.game.templates||{};
svs.numbergames.game.templates.joker = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "  <div id=\"jokerPriceRegion\"></div>\n  <div class=\"js-joker-row-wrapper\">\n    <div class=\"numbergames-footer-section joker-row-section\">\n      <div class=\"joker-row-input-wrapper\">\n        <div id=\"jokerRowRegion\"></div>\n        <div id=\"jokerInputRegion\"></div>\n      </div>\n      <div id=\"topWinRegion\"></div>\n    </div>\n  </div>\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"withoutJokerText") : depth0),{"name":"if","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":12,"column":2},"end":{"line":16,"column":9}}})) != null ? stack1 : "");
},"2":function(container,depth0,helpers,partials,data) {
    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "  <div class=\"js-without-joker-info-text align-center padding-bottom-1\">\n    <p>"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"withoutJokerText") || (depth0 != null ? lookupProperty(depth0,"withoutJokerText") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"withoutJokerText","hash":{},"data":data,"loc":{"start":{"line":14,"column":7},"end":{"line":14,"column":27}}}) : helper)))
    + "</p>\n  </div>\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = (lookupProperty(helpers,"ui")||(depth0 && lookupProperty(depth0,"ui"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"form/fieldset",{"name":"ui","hash":{"srOnly":true,"legend":"Joker"},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":0},"end":{"line":17,"column":7}}})) != null ? stack1 : "");
},"useData":true});
Handlebars.partials['components-numbergames-game-joker'] = svs.numbergames.game.templates.joker;
})(svs, Handlebars);


 })(window);